import conversations from './conversations/route';
import contacts from './contacts/route';
import agents from './agents/route';
import bots from './bots/route';
import teams from './teams/route';
import stats from './stats/route';
import settings from './settings/route';
import automation from './automation/route';
import searchResults from './search-results/route';
import admin from './admin/route';
import login from './login/route';
import logout from './logout/route';
import notFound from './404/route';
import GeckoLocation from '../services/gecko-location';
import GeckoStore from '../services/gecko-store';
import Bootstrap from 'services/bootstrap';
import GeckoAuth from '../services/gecko-auth';
import LoadingIndicator from '../services/loading-indicator';

const auth = {
  path: '',
  action: (context) => {
    // If the route doesn't need authenticated return early
    if (['/login', '/logout'].includes(context.url)) {
      return context.next();
    }
    // If we don't have a token then redirect them to the login screen and return true to not render any more of the route
    return LoadingIndicator.resolve(
      GeckoAuth.getToken().then((token) => {
        GeckoAuth.updateAuthHeaders(token);
        return Bootstrap.bootstrap(token).then(() => {
          context.router.queryParams = GeckoLocation.params;
          context.router.user = GeckoStore.redux.get('appState.loggedInUser');
          return context.next();
        });
      })
    ).catch((error) => {
      console.log('error auth route:::, ', error);
      console.error(error);
      GeckoLocation.goTo('/login');
      return true;
    });
  },
  children: [
    login,
    logout,
    conversations,
    contacts,
    agents,
    bots,
    teams,
    stats,
    settings,
    searchResults,
    automation,
    admin,
    notFound,
  ],
};

export default [auth];
